import React, { useState } from 'react';
import JsonEditor from '../../JsonEditor';
import Icon from '@ant-design/icons';
import EditSvg from '@icons/event-management/edit.svg';
import { Button } from 'antd';

const ConfigurationBlock = ({ data, refetch, handleUpdate, height, showDelete, handleDelete }) => {
  const [open, setOpen] = useState<boolean>(false);

  // show only config to the editor.
  const dataForEditor = {
    config: data.config,
  };

  const handleSave = (jsonData) => {
    const updatedData = { ...data, ...jsonData };
    handleUpdate(updatedData);
  };

  const onDeleteConfig = (jsonData) => {
    const updatedData = { ...data, ...jsonData };
    handleDelete(updatedData);
  };

  return (
    <div style={{ padding: '10px 16px 10px' }}>
      <div style={{ display: 'flex', gap: '5px' }}>
        <div style={{ display: 'flex', minWidth: 180 }}>
          {'<'}
          <Icon component={EditSvg} style={{ fontSize: 'smaller' }} />
          {'> '}
          {`${data?.platform}_${data?.sensor_version}(${data?.config_id})`}
        </div>
        <Button
          size={'small'}
          onClick={() => {
            setOpen(!open);
          }}
        >
          {open ? 'Close' : 'Open'} Editor
        </Button>
      </div>
      {open && (
        <div style={{ padding: '0 16px' }}>
          <JsonEditor
            data={dataForEditor}
            refetch={refetch}
            handleSave={handleSave}
            height={height}
            showDelete={showDelete}
            onDeleteConfig={onDeleteConfig}
          />
        </div>
      )}
    </div>
  );
};

export default ConfigurationBlock;
